// Division-based access helpers (client-side convenience only; backend enforces truth).

export const isAdminRole = (u) => u?.role === "admin" || u?.role === "system_admin";
export const isSupervisor = (u) => u?.role === "supervisor";
export const canManageRecords = (u) => isAdminRole(u) || isSupervisor(u);

export function accessibleDivisionNames(user, divisions) {
  const names = (divisions || []).map((d) => d.name);
  if (!user) return [];
  if (user.role === "system_admin") return names;
  if (user.role === "admin" && user.view_all_divisions) return names;
  const set = new Set(user.authorized_divisions || []);
  if (user.primary_division) set.add(user.primary_division);
  if (user.role === "supervisor") (user.supervised_divisions || []).forEach((d) => set.add(d));
  return names.filter((n) => set.has(n));
}

export const VISIBILITY_OPTIONS = [
  { value: "division", label: "Division only" },
  { value: "selected", label: "Selected divisions" },
  { value: "org", label: "Organization-wide" },
  { value: "supervisors", label: "Supervisors only" },
];

export const VISIBILITY_LABEL = {
  division: "Division only",
  selected: "Selected divisions",
  org: "Organization-wide",
  supervisors: "Supervisors only",
};

export const ROLE_LABEL = {
  employee: "Employee",
  supervisor: "Supervisor",
  admin: "Admin",
  system_admin: "System Owner",
};

export function accessSummary(user) {
  if (!user) return "";
  const parts = [ROLE_LABEL[user.role] || user.role];
  if (user.role === "system_admin") return `${parts[0]} · All organizations`;
  if (user.role === "admin" && user.view_all_divisions) return `${parts[0]} · Views all divisions`;
  const auth = user.authorized_divisions || [];
  if (user.primary_division) parts.push(`Primary: ${user.primary_division}`);
  if (auth.length) parts.push(`Access: ${auth.join(", ")}`);
  if (user.role === "supervisor" && (user.supervised_divisions || []).length)
    parts.push(`Supervises: ${user.supervised_divisions.join(", ")}`);
  return parts.join(" · ");
}
